export default class ReduxActionNotLoggedError extends Error {
    private readonly reduxActionType: string;
    private readonly reduxActionPayload: object;

    constructor(reduxActionType: string, reduxActionPayload: object) {
        super(`Redux action of ${reduxActionType} was not handled for logging.`);
        this.reduxActionType = reduxActionType;
        this.reduxActionPayload = reduxActionPayload;
    }

    public getReduxActionType(): string {
        return this.reduxActionType;
    }

    public getReduxActionPayload(): object {
        return this.reduxActionPayload;
    }
}
